<template>
    <v-navigation-drawer
        id="norfield-mobile-navigation-drawer"
        v-model="navDrawerOpen"
        app
        color="#122448"
        dark
        temporary
        touchless
    >
        <v-list-item
            class="text-center mt-2 px-2"
            @input="toggleNavBar"
        >
            <v-list-item-title>
                <LocatorLogixLogoWhite />
            </v-list-item-title>
        </v-list-item>
        <OfflineNavDrawerContent v-if="offline" />
        <NavDrawerContent v-else />
    </v-navigation-drawer>
</template>

<script>
import NavDrawerContent from './NavDrawerContent';
import OfflineNavDrawerContent from './Offline/OfflineNavDrawerContent';
import LocatorLogixLogoWhite from './CustomIcons/LocatorLogixLogoWhite';
export default {
    components: {
        NavDrawerContent,
        OfflineNavDrawerContent,
        LocatorLogixLogoWhite,
    },
    computed: {
        navDrawerOpen: {
            get() {
                return this.$store.getters.navdrawerOpen;
            },
            set(newValue) {
                this.$store.commit('SET_NAVDRAWER_OPEN', newValue);
            }
        },
        offline() {
            return this.$store.getters.forceOffline;
        },
    },
    methods: {
        toggleNavBar() {
            this.$emit('toggle-navdrawer');
        },
    }
};
</script>
<style>
#norfield-navigation-drawer .v-list-item .app-title {
    font-size: 16pt;
}
</style>
